export default {
  gameBRoute: {
    loadFailed: "Load failed",
    saveSuccess: "Saved successfully",
    saveFailed: "Save failed",
    opSuccess: "Operation successful",
    deleteSuccess: "Deleted successfully",
    deleteConfirm: "Delete this mapping? This cannot be undone",
    addTitle: "Add B-route game mapping",
    editTitle: "Edit B-route game mapping",
    selectAPlatformFirst: "Select an A-route platform first",
    aPlatformRequired: "Please select A-route platform code",
    aGameRequired: "Please select A-route game code",
    bPlatformRequired: "Please select B-route platform code",
    bPlatformPh: "Select B-route platform code",
    bGameCodeHint: "Optional (lobby game; if empty, keeps original game code on the B platform)",
    col: {
      aPlatformCode: "A-route platform code",
      aGameCode: "A-route game code",
      bPlatformCode: "B-route platform code",
      bGameCode: "B-route game code",
      status: "Status",
      createTime: "Created At",
      action: "Action"
    },
    status: { enabled: "Enabled", disabled: "Disabled" },
    btn: { search: "Search", reset: "Reset", add: "Add mapping", edit: "Edit", delete: "Delete", enable: "Enable", disable: "Disable" }
  },
  common: {
    button: {
      save: "Save",
      back: "Back",
      add: "Add",
      edit: "Edit",
      delete: "Delete"
    },
    queryFrm: {
      search: "Search",
      reset: "Reset"
    }
  },
  smsSupplyMgmt: {
    title: "SMS Service Provider",
    countryName: "Country Name",
    countryCode: "Country Code",
    smsSupplyName: "SMS Service Provider",
    operation: "Operation",
    enable: "On",
    disable: "Off",
    confirmOperation: "Confirm Operation",
    enableAction: "Enable",
    disableAction: "Disable",
    confirmEnable: "Are you sure to enable SMS service provider",
    confirmDisable: "Are you sure to disable SMS service provider",
    enableSuccess: "Enable Success",
    disableSuccess: "Disable Success",
    enableFailed: "Enable Failed",
    disableFailed: "Disable Failed",
    fetchDataFailed: "Fetch Data Failed",
    fetchCountryDataFailed: "Fetch Country Data Failed",
    loading: "Loading...",
    unknown: "Unknown",
    bottomTip: "Only one SMS service provider per country",
    paginationTotal: "Total {{total}} records, showing {{start}}-{{end}}"
  },
  gameEntryMgmt: {
    customCategoryManagement: "Custom Category Management",
    gamePlatformManagement: "Game Platform Management",
    gameLine: "Game Line",
    customGameType: "Custom Game Type",
    systemPlatformCategory: "System Platform Category",
    currency: "Currency",
    isEnabled: "Enabled",
    gamePlatformName: "Game Platform Name",
    isMaintenance: "Maintenance",
    yes: "Yes",
    no: "No",
    operation: "Operation",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    enable: "Enable",
    disable: "Disable",
    maintenance: "Maintenance",
    refresh: "Refresh",
    sort: "Sort",
    selectGameLine: "Please select game line",
    selectCurrency: "Please select currency",
    selectStatus: "Please select status",
    selectMaintenanceStatus: "Please select maintenance status",
    pleaseInputSort: "Please input sort",
    selectCustomGameCategory: "Please select custom game category",
    selectGamePlatformCategory: "Please select game platform category",
    operationSuccess: "Operation successful",
    operationFailed: "Operation failed",
    confirmMessage: "Confirm delete",
    confirmDisable: "Confirm disable",
    confirmEnable: "Confirm enable",
    refreshSuccess: "Refresh successful",
    dataLoadFailed: "Data load failed"
  },
  gameHotMgmt: {
    hotGameList: "Hot Game List",
    hotGameLangList: "Hot Game Language List",
    displayMethod: "Display Method",
    platformName: "Platform Name",
    gameName: "Game Name",
    gameLine: "Game Line",
    currency: "Currency",
    sort: "Sort",
    manualSort: "Manual Sort",
    autoSort: "Auto Sort",
    isEnabled: "Enabled",
    yes: "Yes",
    no: "No",
    confirmDisable: "Confirm Disable",
    confirmEnable: "Confirm Enable",
    confirmDelete: "Confirm Delete",
    operationSuccess: "Operation Successful",
    operationFailed: "Operation Failed",
    dataLoadFailed: "Data Load Failed",
    add: "Add",
    edit: "Edit",
    hotGame: "Hot Game",
    language: "Language",
    entryImage: "Entry Image",
    uploadEntryImage: "Entry Image Not Uploaded",
    gamePlatform: "Game Platform",
    game: "Game",
    customGameCategory: "Custom Game Category",
    pleaseSelectDisplayMethod: "Please Select Display Method",
    pleaseSelectLine: "Please Select Line",
    pleaseSelectCustomGameCategory: "Please Select Custom Game Category",
    pleaseSelectGamePlatform: "Please Select Game Platform",
    pleaseSelectGame: "Please Select Game",
    pleaseInputSort: "Please Input Sort",
    pleaseSelectLanguage: "Please Select Language",
    pleaseSelectHotGame: "Please Select Hot Game",
    pleaseSelectStatus: "Please Select Status",
    pleaseInputGameName: "Please Input Game Name",
    pleaseInputPlatformName: "Please Input Platform Name",
    setMultiLanguage: "Set Multi Language",
    formValidationFailed: "Form Validation Failed",
    addSuccess: "Add Success",
    editSuccess: "Edit Success",
    icon: "Icon",
    status: "Status",
    enabled: "Enabled",
    disabled: "Disabled",
    pleaseSelectCurrency: "Please Select Currency"
  },
  gameListMgmt: {
    gameMainData: "Game Main Data",
    gameLangData: "Language Data",
    platformCategory: "Platform Category",
    gamePlatform: "Game Platform",
    gameName: "Game Name",
    gameCode: "Game Code",
    sort: "Sort",
    manualSort: "Manual Sort",
    autoSort: "Auto Sort",
    effectMode: "Effect Mode",
    isPcSupported: "PC Support",
    isH5Supported: "H5 Support",
    displayName: "Display Name",
    gameEntryIcon: "Game Entry Icon",
    batchAdd: "Batch Add",
    save: "Save",
    back: "Back",
    setMultiLanguage: "Set Multi Language",
    addGameLangData: "Add Game Language Data",
    editGameLangData: "Edit Game Language Data",
    gameSystemName: "Game System Name",
    language: "Language",
    confirmDelete: "Confirm Delete",
    confirmEnable: "Confirm Enable",
    confirmDisable: "Confirm Disable",
    pleaseSelectCategory: "Please Select Category",
    pleaseSelectPlatform: "Please Select Platform",
    pleaseInputGameName: "Please Input Game Name",
    pleaseInputGameCode: "Please Input Game Code",
    pleaseInputSort: "Please Input Sort",
    pleaseSelectPcSupport: "Please Select PC Support",
    pleaseSelectH5Support: "Please Select H5 Support",
    pleaseInputDisplayName: "Please Input Display Name",
    pleaseSelectLanguage: "Please Select Language",
    addSuccess: "Add Success",
    editSuccess: "Edit Success",
    formValidationFailed: "Form Validation Failed",
    dataLoadFailed: "Data Load Failed",
    operationSuccess: "Operation Success",
    operationFailed: "Operation Failed",
    uploadImgStatus: "img status",
    pleaseSelectIsUploadImg: "all",
    uploadImage: "uploaded",
    noUploadImage: "not uploaded",
    highRiskGame: "High Risk Game",
    highRiskConfig: "High Risk Game",
    highRiskNo: "No",
    highRiskYes: "Yes",
    highRiskFilterAll: "All",
    tagImg: "Game Tag",
    uploadNeedGameInfo: "Please select the game platform and game (or enter the game code) before uploading images",
    tagImgHint: "64 × 40 px, max 50 KB",
    notConfigured: "Not Configured",
    h5Image: "H5 Image (Mobile)",
    pcImage: "PC Image (Kiosk / Desktop)",
    h5ImageHint: "Used by H5 mobile client",
    pcImageHint: "Used by offline kiosk / PC client",
    missingH5: "No H5 (Mobile)",
    missingPc: "No PC (Kiosk)",
    imgStatusAll: "All",
    imgStatusH5Only: "H5 only (no Kiosk)",
    imgStatusPcOnly: "PC only (no Mobile)",
    imgStatusBoth: "Both",
    imgStatusNone: "Neither",
    currency: "Currency",
    pleaseSelectCurrency: "Please select currency"
  },
  gamePlatformMgmt: {
    mainData: "Platform Main Data",
    languageData: "Language Data",
    currencyData: "Currency Data",
    platformName: "Platform Name",
    platformKey: "Platform Key",
    platformType: "Platform Type",
    platformCategory: "Platform Category",
    platform: "Platform",
    platformDisplayName: "Platform Display Name",
    platformDesc: "Platform Description",
    platformMaintainNotice: "Maintenance Notice",
    platformLogo: "Platform Logo",
    platformEntryIcon: "Platform Entry Icon",
    language: "Language",
    currency: "Currency",
    displayName: "Display Name",
    addPlatformLangData: "Add Platform Language Data",
    setMultiLanguage: "Set Multi Language",
    pleaseInputPlatformName: "Please input platform name",
    pleaseInputPlatformKey: "Please input platform key",
    pleaseSelectPlatformType: "Please select platform type",
    pleaseSelectPlatformCategory: "Please select platform category",
    pleaseSelectPlatform: "Please select platform",
    pleaseInputDisplayName: "Please input display name",
    pleaseInputPlatformDesc: "Please input platform description",
    pleaseInputMaintainNotice: "Please input maintenance notice",
    pleaseSelectLanguage: "Please select language",
    pleaseSelectCurrency: "Please select currency",
    dataLoadFailed: "Data load failed",
    formValidationFailed: "Form validation failed",
    addSuccess: "Add success",
    editSuccess: "Edit success",
    operationSuccess: "Operation success",
    operationFailed: "Operation failed",
    confirmDeletePlatform: "Confirm delete platform",
    confirmDeletePlatformCurrency: "Confirm delete platform currency",
    platformCurrency: "Platform Currency",
    column: {
      title: {
        index: "Index",
        gamePlatformName: "Platform Name",
        gamePlatformCode: "Platform Code",
        bRouteCode: "B-Route Platform Code",
        gameType: "Platform Type",
        desc: "Description",
        gameFullName: "Platform Full Name",
        gameShowName: "Display Name",
        action: "Action",
        platformName: "Platform Name",
        platformType: "Platform Type",
        currency: "Currency"
      }
    }
  },
  // Game line name map (backend stores Chinese names only; Chinese name is the key)
  gameLineName: {
    "美国": "USA",
    "墨西哥": "Mexico",
    "菲律宾": "Philippines"
  },
  // Game category name map (dict 31004/31005 store Chinese itemName only)
  gameCategoryName: {
    "电子": "Slots",
    "真人": "Live Casino",
    "体育": "Sports",
    "彩票": "Lottery",
    "捕鱼": "Fishing",
    "棋牌": "Card & Board",
    "电竞": "eSports",
    "小游戏": "Mini Games",
    "竞猜": "Prediction",
    "街机": "Arcade",
    "宾果": "Bingo"
  },
  gamePromotMgmt: {
    mainPromotGamePlatform: "Main Promoted Game Platform",
    entryImage: "Entry Image",
    platform: "Platform",
    gamePlatform: "Game Platform",
    currency: "Currency",
    sort: "Sort",
    status: "Status",
    enabled: "Enabled",
    disabled: "Disabled",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    confirmDelete: "Confirm Delete",
    confirmDisable: "Confirm Disable",
    confirmEnable: "Confirm Enable",
    addSuccess: "Add Success",
    editSuccess: "Edit Success",
    operationSuccess: "Operation Success",
    operationFailed: "Operation Failed",
    dataLoadFailed: "Data Load Failed",
    formValidationFailed: "Form Validation Failed",
    pleaseSelectPlatform: "Please Select Platform",
    pleaseSelectGamePlatform: "Please Select Game Platform",
    pleaseInputSort: "Please Input Sort",
    pleaseSelectCurrency: "Please Select Currency",
    pleaseSelectStatus: "Please Select Status",
    column: {
      title: {
        index: "Index",
        platformName: "Platform Name",
        gamePlatformName: "Game Platform Name",
        gameLine: "Game Line",
        currency: "Currency",
        sort: "Sort",
        status: "Status",
        action: "Action"
      }
    }
  },
  gameRecMgmt: {
    mainGameList: "Main Game List",
    mainGameLangList: "Main Game Language List",
    displayMethod: "Display Method",
    platformName: "Platform Name",
    gameName: "Game Name",
    gameLine: "Game Line",
    currency: "Currency",
    sort: "Sort",
    manualSort: "Manual Sort",
    autoSort: "Auto Sort",
    status: "Status",
    enabled: "Enabled",
    disabled: "Disabled",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    confirmDelete: "Confirm Delete",
    confirmDisable: "Confirm Disable",
    confirmEnable: "Confirm Enable",
    addSuccess: "Add Success",
    editSuccess: "Edit Success",
    operationSuccess: "Operation Success",
    operationFailed: "Operation Failed",
    dataLoadFailed: "Data Load Failed",
    formValidationFailed: "Form Validation Failed",
    pleaseSelectPlatform: "Please Select Platform",
    pleaseSelectGamePlatform: "Please Select Game Platform",
    pleaseInputSort: "Please Input Sort",
    pleaseSelectCurrency: "Please Select Currency",
    pleaseSelectStatus: "Please Select Status",
    pleaseSelectLanguage: "Please Select Language",
    pleaseSelectGame: "Please Select Game",
    pleaseSelectCustomGameCategory: "Please Select Custom Game Category",
    entryImage: "Entry Image",
    uploadEntryImage: "Entry Image Not Uploaded",
    gamePlatform: "Game Platform",
    game: "Game",
    customGameCategory: "Custom Game Category",
    language: "Language",
    setMultiLanguage: "Set Multi Language",
    column: {
      title: {
        index: "Index",
        platformName: "Platform Name",
        gamePlatformName: "Game Platform Name",
        gameName: "Game Name",
        gameLine: "Game Line",
        currency: "Currency",
        sort: "Sort",
        status: "Status",
        action: "Action",
        icon: "Icon",
        language: "Language"
      }
    }
  },
  gameTypeMgmt: {
    editType: "Edit Type",
    type: "Type",
    typeRequired: "Please Input Type",
    pleaseInputType: "Please Input Type",
    gamePlatform: "Game Platform",
    pleaseSelectGamePlatform: "Please Select Game Platform",
    icon: "Icon",
    uploadIconRequired: "Please Upload Icon",
    menuIcon: "Menu Icon",
    updateSuccess: "Update Success",
    updateFailed: "Update Failed",
    language: "Language",
    pleaseSelectLanguage: "Please Select Language",
    yes: "Yes",
    no: "No",
    dataLoadFailed: "Data Load Failed",
    operationSuccess: "Operation Success",
    operationFailed: "Operation Failed",
    column: {
      title: {
        index: "Index",
        gameGroupName: "Game Group Name",
        gameStatus: "Game Status",
        operateAction: "Operation",
        language: "Language",
        icon: "Icon",
        menuIcon: "Menu Icon"
      }
    }
  },
  gameModuleMgmt: {
    yes: "Yes",
    no: "No",
    pageTitle: "Client Module Management",
    line: "Line",
    language: "Language",
    selectLine: "Please select line",
    selectLanguage: "Please select language",
    clientTab: "Client Tabs",
    modulesCount: "{{count}} modules",
    moduleListTitle: "Tab · Module List (Total {{count}} modules)",
    selectTabHint: "Please select line & language, then click a Tab",
    systemLocked: "🔒 System Module (Read-only)",
    jumpToSource: "⚙ Go to Source Menu",
    addModule: "+ Add Module",
    editModule: "Edit Module",
    configGame: "⚙ Configure Games",
    back: "Back",
    confirmDelete: "Confirm to delete this module?",
    addSuccess: "Added successfully",
    editSuccess: "Updated successfully",
    deleteSuccess: "Deleted successfully",
    platformOrTabRequired: "Please select a line and a tab first",
    manualSort: "Manual Sort",
    autoSort: "Auto Sort",
    autoSortRule: "Auto Sort Rule",
    resetDate: "Reset Date",
    resetTime: "Reset Time",
    daily: "Daily",
    weekly: "Weekly",
    column: {
      sort: "Sort",
      autoSortRule: "Auto Sort Rule",
      icon: "Icon",
      label: "Label",
      name: "Module Name",
      isSystem: "Is System",
      status: "Status",
      action: "Action"
    },
    add: { title: "Add Module" },
    edit: { title: "Edit Module" },
    form: {
      sort: "Sort",
      sortRequired: "Please enter sort",
      sortMustBeInteger: "Sort must be an integer",
      moduleName: "Module Name",
      moduleNameRequired: "Please enter module name",
      iconUrl: "Module Icon",
      iconUrlRequired: "Please upload module icon",
      gameLabelUrl: "Game Label",
      remark: "Remark",
      remarkPlaceholder: "Module rules, data source, operation notes (back-office only)",
      langSelect: "Languages",
      langSelectRequired: "Please select languages",
      langHint: "⚙ Module Name / Icon / Game Label / Remark are maintained per language",
      displayRows: "Display Rows",
      displayRowsRequired: "Please select display rows",
      displayRows1: "1*3 (1 row / 3 games)",
      displayRows2: "2*3 (2 rows / 6 games)",
      displayRows3: "3*3 (3 rows / 9 games)",
      displayRowsKiosk1: "1*7 (1 row / 7 games)",
      displayRowsKiosk2: "2*7 (2 rows / 14 games)",
      displayRowsKiosk3: "3*7 (3 rows / 21 games)"
    },
    gameConfig: {
      module: "Module",
      attached: "Attached",
      attachedCount: "{{count}} games",
      addGame: "Add",
      batchRemove: "Batch Remove",
      remove: "Remove",
      confirmRemove: "Confirm to remove this game from the module?",
      confirmBatchRemove: "Confirm to remove the selected {{count}} games from this module?",
      removeSuccess: "Removed",
      selectAtLeastOne: "Please select at least one game"
    },
    gameAdd: {
      title: "Select games from \"Sub-game Settings\" to attach to this module",
      index: "Index",
      gameType: "Platform Category",
      gamePlatform: "Game Platform",
      gameName: "Game Name",
      gameNamePlaceholder: "Enter game name",
      selectGameType: "Select platform category",
      selectGamePlatform: "Select game platform",
      platformRequired: "Please select a game platform first",
      selectAtLeastOne: "Please check at least one game",
      addSuccess: "Added successfully"
    }
  },
  desktopGameModuleMgmt: {
    pageTitle: "Desktop Module Management",
    desktopTab: "Desktop Tab",
    copyFromClient: "Copy from Client",
    copyFromClientHint: "Desktop modules are stored independently from client modules. Use copy-from-client to bootstrap all groups from existing client configuration.",
    copyFromClientConfirm: "Confirm copying all groups from client? System modules are de-duplicated by code; custom modules are copied only for groups that are currently empty. No existing data is overwritten.",
    copyFromClientResult: "Copied {{count}} module(s)",
    selectLineFirst: "Please select a line first"
  }
};
